import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLaptop = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14 10.6667V4.80008C14 4.05334 14 3.67998 13.8547 3.39476C13.7269 3.14388 13.5229 2.9399 13.272 2.81207C12.9868 2.66675 12.6134 2.66675 11.8667 2.66675H4.13337C3.38664 2.66675 3.01327 2.66675 2.72805 2.81207C2.47717 2.9399 2.2732 3.14388 2.14537 3.39476C2.00004 3.67998 2.00004 4.05334 2.00004 4.80008V10.6667M3.11115 13.3334H12.8889C13.3022 13.3334 13.5089 13.3334 13.6785 13.288C14.1386 13.1647 14.498 12.8053 14.6213 12.3452C14.6667 12.1756 14.6667 11.969 14.6667 11.5556C14.6667 11.349 14.6667 11.2456 14.644 11.1609C14.5823 10.9308 14.4026 10.7511 14.1726 10.6895C14.0878 10.6667 13.9845 10.6667 13.7778 10.6667H2.22226C2.0156 10.6667 1.91227 10.6667 1.82749 10.6895C1.59743 10.7511 1.41773 10.9308 1.35609 11.1609C1.33337 11.2456 1.33337 11.349 1.33337 11.5556C1.33337 11.969 1.33337 12.1756 1.37881 12.3452C1.5021 12.8053 1.86149 13.1647 2.32162 13.288C2.49117 13.3334 2.69783 13.3334 3.11115 13.3334Z",
		stroke: "white",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLaptop;
